import ReportConsolidadoEmpresasPreview from "./ReportConsolidadoEmpresasPreview";
export default ReportConsolidadoEmpresasPreview;